<div class="filter-label">
    <label title="{{props['fieldDescription']}}" class="field-label mt-2 {{ getStatus() }} {{ getFilterFontStatus() }}" *ngIf="props.label"
        [attr.id]="id + '-label'" (click)="conmuteHide()">
        {{ props.label }}
    </label>
</div>

<div *ngIf="!this.hide" class="filter-container">
    <div *ngIf="false" class="filter-description">
        <span class="field-description">{{ props.fieldDescription }}</span>
    </div>
    <div class="filter-content bulk-date-wrapper">
        <div>
            <p-calendar  appendTo="body" [view]="calendarView" (onSelect)="onSelect($event)"
                dataType="string" [dateFormat]="dateFormat" [formControl]="formControl" [inputStyle]="style"
                 (ngModelChange)="updateCheckbox()">
            </p-calendar>
        </div>
        <div style="margin-left: auto;">
            <button *ngIf="showClear()" type="button" class="btn btn-light" title="Clear selected Options"
                (click)="clear()">Clear</button>
        </div>
    </div>
</div>